export default [
  {
    url: null,
    name: 'Dashboard',
    tagColor: 'warning',
    icon: 'HomeIcon',
    i18n: 'Dashboard.Title',
    submenu: [
      {
        url: '/dashboard/campaign',
        name: 'Analytics',
        slug: 'dashboard-campaign',
        i18n: 'Dashboard.Analytics'
      },
      {
        url: '/dashboard/campaigndata?initial=true',
        name: 'Analytics Data',
        slug: 'dashboard-campaign-data',
        i18n: 'Dashboard.AnalyticsData'
      }
    ]
  },
  {
    header: 'Manage',
    icon: 'PackageIcon',
    i18n: 'Manage',
    rule: 'retailer',
    items: [
      {
        url: '/campaign/list?initial=true',
        name: 'CampaignList',
        slug: 'campaign-list',
        icon: 'ListIcon',
        i18n: 'Campaign.List'
      },
      {
        url: '/order/list?initial=true',
        name: 'OrderList',
        slug: 'order-list',
        icon: 'ListIcon',
        i18n: 'Order.List'
      },
      {
        url: '/retailer/list?initial=true',
        name: 'RetailerList',
        slug: 'retailer-list',
        icon: 'ListIcon',
        i18n: 'Retailer.List'
      },
      {
        url: '/jobfeed/list?initial=true',
        name: 'JobFeedList',
        slug: 'jobfeed-list',
        icon: 'ListIcon',
        i18n: 'JobFeed.List'
      },
      {
        url: '/articlelist/list?initial=true',
        name: 'ArticleListList',
        slug: 'article-list-list',
        icon: 'ListIcon',
        i18n: 'ArticleList.List'
      },
      {
        url: '/newsarticlelist/list?initial=true',
        name: 'NewsArticleListList',
        slug: 'new-article-list-list',
        icon: 'ListIcon',
        i18n: 'NewsArticleList.List'
      },
      {
        url: '/voucher/list?initial=true',
        name: 'VoucherList',
        slug: 'voucher-list',
        icon: 'ListIcon',
        i18n: 'Voucher.List'
      },
    ]
  },
  {
    header: 'Admin',
    icon: 'PackageIcon',
    i18n: 'Admin',
    rule: 'editor',
    items: [
      {
        url: '/organisation/list?initial=true',
        name: 'OrganisationList',
        slug: 'organisation-list',
        icon: 'ListIcon',
        i18n: 'Organisation.List',
        rule: 'editor'
      },
      {
        url: '/advertiser/list?initial=true',
        name: 'AdvertiserList',
        slug: 'advertiser-list',
        icon: 'ListIcon',
        i18n: 'Advertiser.List',
        rule: 'admin'
      },
    ]
  }
]
